export default __webpack_public_path__ + "static/media/bg_1.0e5653c9.webp";